import type { ReactNode } from "react"
import { SidebarInset } from "@/components/ui/sidebar"

export function DashboardShell({ children }: { children: ReactNode }) {
  return (
    <SidebarInset>
      {children}
      <footer className="mt-auto px-6 py-4 border-t border-border">
        <p className="text-xs text-muted-foreground text-center">
          {`© ${new Date().getFullYear()} Kanu Energy. All rights reserved.`}
        </p>
      </footer>
    </SidebarInset>
  )
}
